import React from "react";

import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import GigCalendar from "../GigCalendar/GigCalendar";
import BookingForm from "../BookingForm/BookingForm";
import { MdArrowBack } from "react-icons/md";
import { LoadScript } from "@react-google-maps/api";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube, FaStar, FaRegStar } from "react-icons/fa";
import BandGallery from "../BandGallery/BandGallery";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import CustomAudioPlayer from "../CustomAudioPlayer/CustomAudioPlayer";
import { getBandFeatures } from "../../helpers/membershipFeatures";

const BandProfile = () => {
  const { slug } = useParams();
  const location = useLocation();
const isPreview = new URLSearchParams(location.search).get("preview") === "true";

  const navigate = useNavigate();
  const [band, setBand] = useState(null);
  const [error, setError] = useState("");
  const [refreshKey, setRefreshKey] = useState(Date.now()); // ⬅️ LISÄÄ TÄMÄ
  const [selectedDate, setSelectedDate] = useState(null);
  const [formMode, setFormMode] = useState("setit");
  const [timeLeft, setTimeLeft] = useState(null);
  const features = band ? getBandFeatures(band.membership_level) : {};


  const safeParseArray = (input) => {
    if (!input) return [];
    if (Array.isArray(input)) return input;
  
    if (typeof input === "string") {
      try {
        const parsed = JSON.parse(input);
        return Array.isArray(parsed) ? parsed : [input];
      } catch {
        return [input]; // ei JSON → käsitellään yksittäisenä linkkinä
      }
    }
  
    return [];
  };
  
  useEffect(() => {
    AOS.init({ offset: 100, duration: 800 });
  }, []);

  // Esimerkkinä: alustetaan 24h määräaika backendistä saadun timestampin perusteella
  useEffect(() => {
    if (selectedDate?.status === "pending" && selectedDate?.sent_at) {
      const deadline = new Date(selectedDate.sent_at).getTime() + 24 * 60 * 60 * 1000; // 24 tuntia
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const diff = deadline - now;
  
        if (diff <= 0) {
          clearInterval(interval);
          setTimeLeft("00:00:00");
  
          // ✅ Suljetaan lomake automaattisesti
          setSelectedDate(null);
          setFormMode("setit");
  
          // ✅ Päivitetään kalenteri hakemaan uudestaan
          setRefreshKey(Date.now());
        } else {
          const hours = Math.floor(diff / (1000 * 60 * 60));
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
          setTimeLeft(
            `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
          );
        }
      }, 1000);
  
      return () => clearInterval(interval);
    }
  }, [selectedDate]);
  
  // Haetaan bändin tiedot slugilla
  useEffect(() => {
    axios
      .get(`https://spiderlegsproductions.com/api/get_band.php?slug=${slug}`)
      .then((response) => {
        if (response.data.success) {
          setBand(response.data.band);
        } else {
          setError(response.data.error);
        }
      })
      .catch((err) => {
        console.error("Virhe bändin haussa:", err);
        setError("Jotain meni pieleen bändin tietojen hakemisessa.");
      });
  }, [slug]);

  const handleDateSelect = (date, status = "free", sentAt = null) => {
    const dateObj = new Date(date);
    const weekday = dateObj.toLocaleDateString("fi-FI", { weekday: "long" }).replace(/na$/, "");
    const formattedDate = `${weekday} ${dateObj.getDate()}.${dateObj.getMonth() + 1}.${dateObj.getFullYear()}`;
    const iso = dateObj.toISOString().split("T")[0];
  
    setSelectedDate({ iso, formatted: formattedDate, status, sent_at: sentAt });
    setFormMode("setit");
  };
  
  
  

  if (error) {
    return (
      <div className="p-5">
        <p className="text-red-500">Virhe: {error}</p>
        <ResponsiveButton onClick={() => navigate(-1)}>
          Takaisin
        </ResponsiveButton>
      </div>
    );
  }

  if (!band) {
    return <div className="p-5">Ladataan bändin tietoja...</div>;
  }

  const isPremium = band.membership_level === "premium"; // ✅ LISÄÄ TÄMÄ TÄHÄN

  return (
    <div className="pt-12 dark:bg-opacity-75 dark:bg-black bg-linkcol pb-10 mt-2" data-aos="fade">
<Helmet>
  {/* Title ja Meta Description */}
  <title>Spiderlegs Productions | {band.name}</title>
  <meta
    name="description"
    content={`${band.name} – ${band.genre}. Tarjoamme ${band.available_sets || "useita"} settiä. Varaa keikka tai ota yhteyttä!`}
  />
  <meta
    name="keywords"
    content={`keikat, esiintyjä, bändi, ${band.name}, ${band.genre}, livemusiikki, Spiderlegs Productions`}
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content={`Spiderlegs Productions | ${band.name}`} />
  <meta
    property="og:description"
    content={`${band.name} – ${band.genre}. Katso tiedot ja varaa keikka!`}
  />
  <meta
    property="og:image"
    content={band.profile_image || "https://spiderlegsproductions.com/assets/fallback.jpg"}
  />
  <meta
    property="og:url"
    content={`https://spiderlegsproductions.com/esiintyja/${band.slug}`}
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={`Spiderlegs Productions | ${band.name}`} />
  <meta
    name="twitter:description"
    content={`${band.name} – ${band.genre}. Tutustu ja varaa keikka helposti!`}
  />
  <meta
    name="twitter:image"
    content={band.profile_image || "https://spiderlegsproductions.com/assets/fallback.jpg"}
  />

  {/* Canonical */}
  <link
    rel="canonical"
    href={`https://spiderlegsproductions.com/esiintyja/${band.slug}`}
  />
</Helmet>

    <div className="h-10"></div>

      <ResponsiveButton
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate("/");
          }
          setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
        }}
        variant="backbutton"
        className="ml-4"
      >
        <div className="flex items-center gap-2">
          <MdArrowBack className="text-xl" />
          <span>Takaisin</span>
        </div>
      </ResponsiveButton>

      {/* Bändin kansikuva ja nimi */}
      <div className="max-w-6xl mx-auto mt-6" data-aos="fade-up" data-aos-duration="800">
        <h1 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight mb-4">
          {band.name}
        </h1>
        {band.profile_image && (
          <div className="max-w-[1104px] mx-auto overflow-visible rounded-lg shadow-md">
            <img
              src={band.profile_image}
              alt={band.name}
              className="w-full h-auto object-cover"
            />
          </div>
        )}
      </div>

      {isPreview && (
  <div className="max-w-6xl mx-auto mt-4 flex justify-center">
    <ResponsiveButton
      onClick={() => navigate("/performer-dashboard")}
      variant="backbutton"
    >
      <div className="flex items-center gap-2">
        <MdArrowBack className="text-xl" />
        <span>Takaisin hallintapaneeliin</span>
      </div>
    </ResponsiveButton>
  </div>
)}


      {/* Bändin kuvaus */}
      {band.description && (
        <div
          className="max-w-6xl mx-auto mt-4 p-4 bg-primary dark:bg-violet rounded-lg shadow-md"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
            {band.description.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      )}

      {/* Bändin galleria */}
      {features.canUseGallery && safeParseArray(band.gallery_images).length > 0 && (
        <div className="max-w-6xl mx-auto p-4 mt-6 bg-primary dark:bg-violet rounded-lg shadow-md" data-aos="fade-up" data-aos-duration="800">
          <BandGallery images={safeParseArray(band.gallery_images)} bandName={band.name} />
        </div>
      )}


      {/* Tiedot ja arvostelut */}
      <div
        className="mt-6 max-w-6xl mx-auto p-6 bg-primary dark:bg-violet rounded-lg shadow-lg grid grid-cols-1 md:grid-cols-2 mdd:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-6"
        data-aos="fade-up"
        data-aos-duration="800"
      >
       {/* Videot */}
        {features.showVideo && band.video_link && band.video_link.trim() !== "" && (
          <div className="flex flex-col">
            <h3 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight">
              Videot
            </h3>
            <iframe
              width="100%"
              height="315"
              src={band.video_link}
              title="YouTube video player"
              frameBorder="0"
              allowFullScreen
              className="rounded-lg"
            ></iframe>
          </div>
        )}

        {/* Tiedot */}
        <div className="flex flex-col" data-aos="fade-up" data-aos-duration="800">
          <div className="ml-4">
            <h3 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight mb-4">
              Tiedot
            </h3>
            {band.genre && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Musiikkityyli:</span> {band.genre}
              </p>
            )}
            {band.performance_regions && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Esiintymisalueet:</span> {band.performance_regions}
              </p>
            )}
            {band.artist_type && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Tyyppi:</span> {band.artist_type}
              </p>
            )}
            {band.available_sets && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Saatavilla olevat setit:</span> {band.available_sets}
              </p>
            )}
            {band.instruments && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Soittimet:</span> {band.instruments}
              </p>
            )}
            {band.additional_services && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Muut palvelut:</span> {band.additional_services}
              </p>
            )}
            {band.feedback && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-thin">
                <span className="font-semibold">Palaute:</span> {band.feedback}
              </p>
            )}
            {band.location && (
              <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light">
                <span className="font-semibold">Paikkakunta:</span> {band.location}
              </p>
            )}

            {/* Näytetään arvostelut ja tähdet vain premium-profiileille */}
            {band.membership_level === "premium" ? (
              band.total_reviews > 0 && !isNaN(parseFloat(band.average_rating)) ? (
                <div className="flex items-center mt-2">
                  <span className="font-customFont1 text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
                    {parseFloat(band.average_rating).toFixed(1)} / 5
                  </span>
                  <div className="ml-2 flex">
                    {[...Array(5)].map((_, index) =>
                      index < Math.round(parseFloat(band.average_rating)) ? (
                        <FaStar key={index} className="text-yellow-400" />
                      ) : (
                        <FaRegStar key={index} className="text-gray-400" />
                      )
                    )}
                  </div>
                  <span className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-bold ml-3">
                    ({band.total_reviews})
                  </span>
                </div>
              ) : (
                <p className="font-customFont1 text-left text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-bold mt-2 mb-6">
                  Ei vielä arvosteluja
                </p>
              )
            ) : null}


           {/* Somekanavat */}
            {features.socialLinks && (band.facebook || band.instagram || band.tiktok || band.youtube) && (
              <div className="max-w-6xl mx-auto flex space-x-6 justify-center mt-6" data-aos="fade-in" data-aos-duration="1200">
                {band.facebook && (
                  <a href={band.facebook} target="_blank" rel="noopener noreferrer" aria-label={`${band.name} Facebook`} className="group relative transition-transform transform hover:scale-125 duration-300 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none">
                    <FaFacebook size={35} className="text-blue-600 hover:text-blue-700 transition-colors duration-300" />
                    <span className="absolute z-50 -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:translate-y-2 transition-all duration-300 bg-blue-600 text-white text-xs px-2 py-1 rounded-md">
                      Facebook
                    </span>
                  </a>
                )}
                {band.instagram && (
                  <a href={band.instagram} target="_blank" rel="noopener noreferrer" aria-label={`${band.name} Instagram`} className="group relative transition-transform transform hover:scale-125 duration-300 focus-visible:ring-2 focus-visible:ring-pink-500 focus-visible:outline-none">
                    <FaInstagram size={35} className="text-pink-500 hover:text-pink-600 transition-colors duration-300" />
                    <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:translate-y-2 transition-all duration-300 bg-pink-500 text-white text-xs px-2 py-1 rounded-md">
                      Instagram
                    </span>
                  </a>
                )}
                {band.tiktok && (
                  <a href={band.tiktok} target="_blank" rel="noopener noreferrer" aria-label={`${band.name} TikTok`} className="group relative transition-transform transform hover:scale-125 duration-300 focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:outline-none">
                    <FaTiktok size={35} className="text-black dark:text-white hover:text-gray-700 dark:hover:text-gray-300 transition-colors duration-300" />
                    <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:translate-y-2 transition-all duration-300 bg-gray-800 text-white text-xs px-2 py-1 rounded-md">
                      TikTok
                    </span>
                  </a>
                )}
                {band.youtube && (
                  <a href={band.youtube} target="_blank" rel="noopener noreferrer" aria-label={`${band.name} YouTube`} className="group relative transition-transform transform hover:scale-125 duration-300 focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:outline-none">
                    <FaYoutube size={35} className="text-red-600 hover:text-red-700 transition-colors duration-300" />
                    <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:translate-y-2 transition-all duration-300 bg-red-600 text-white text-xs px-2 py-1 rounded-md">
                      YouTube
                    </span>
                  </a>
                )}
              </div>
            )}
      </div>
        </div>
      </div>

  {/* Audio Tracks -lohko */}
      <div
        className="mt-6 max-w-6xl mx-auto p-6 bg-primary dark:bg-violet rounded-lg shadow-lg space-y-6"
        data-aos="fade-up"
        data-aos-duration="800"
      >
        {safeParseArray(band.audio_tracks).map((trackUrl, idx) => {
          const isSC = trackUrl.includes("soundcloud.com");
          return isSC ? (
            <div key={idx} className="w-full overflow-hidden rounded-lg">
            <iframe
        key={idx}
        width="100%"
        height="200" // korkeampi jotta visual toimii
        allow="autoplay"
        scrolling="no"
        frameBorder="no"
        title={`audio-track-${idx}`}
        className="w-full rounded-lg"
        src={`https://w.soundcloud.com/player/?${new URLSearchParams({
          url: trackUrl,
          auto_play: "false",
          hide_related: "false",
          show_comments: "true",
          show_user: "true",
          show_reposts: "false",
          visual: "true" // tämä näyttää ison version
        })}`}
      />

            </div>
          ) : (
            <div key={idx} className="w-full">
              <CustomAudioPlayer src={trackUrl} />
            </div>
          );
        })}
      </div>




      {/* Keikkakalenteri ja Yhteydenottolomake */}
      <div
        className="max-w-6xl mx-auto mt-6 grid grid-cols-1 md:grid-cols-2 mdd:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-6"
        data-aos="fadin"
        data-aos-duration="800"
      >
        <div className="p-6 bg-primary dark:bg-violet rounded-lg shadow-lg">
          <h3 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-4xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight">
            Keikkakalenteri
          </h3>
          <GigCalendar bandId={band.id} onDateSelect={handleDateSelect} refreshKey={refreshKey} />


        </div>
        <div className="p-6 bg-primary dark:bg-violet rounded-lg shadow-lg">
          <h3 className="font-customFont2 dark:text-shadow-lg text-center text-darkest dark:text-primary text-3xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight mb-4">
            Yhteydenottolomake
          </h3>
          {selectedDate ? (
          <>
          <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light mt-4">
            Olet valinnut päivän: <strong>{selectedDate.formatted}</strong>
          </p>

          {!selectedDate?.status && (
            <p className="text-red-500 font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
              ⚠️ Päivän status puuttuu – debug: {JSON.stringify(selectedDate)}
            </p>
          )}

          {selectedDate?.status === "booked" ? (
            <div className="relative">
              <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center rounded-lg z-10">
                <p className="text-white xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg text-center font-customFont1">
                  Valitettavasti {band.name} on jo varattu kyseisellä päivämäärällä.
                  <br />
                  <span style={{ fontSize: "30px" }}>&#128546;</span>
                </p>
              </div>
              <div className="blur-sm pointer-events-none h-[500px] rounded-lg bg-white/10" />
            </div>
          ) : selectedDate?.status === "pending" ? (
            <div className="relative">
              <div className="absolute inset-0 bg-black bg-opacity-70 flex flex-col items-center justify-center rounded-lg z-10 p-4 text-center">
              <p className="text-white xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-customFont1 mb-2">
          Tarjouspyyntö on käsittelyssä – neuvottelut käyvät kuumana! ♨️
        </p>

        <p className="text-white text-lg font-customFont1">
          Tarjous raukeaa:{" "}
          <span className="font-bold text-darkest dark:text-primary dark:text-shadow-lg xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg">
            {timeLeft ? timeLeft : "Ladataan..."}
          </span>
        </p>
        <span style={{ fontSize: "30px" }}>&#127908;</span>
      </div>
      <div className="blur-sm pointer-events-none h-[500px] rounded-lg bg-white/10" />
    </div>
  ) : (
  
    <>
      <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-bold mt-2">
        {band.name} on vapaana kyseisenä päivänä!
        <br />
        <span style={{ fontSize: "30px" }}>&#129395;</span>
      </p>

      <LoadScript
        key={formMode} // 🔑 TÄMÄ ratkaisee jumituksen kun lomakkeen moodi vaihtuu
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["places"]}
        loadingElement={<div style={{ display: "none" }} />}
      >
        <BookingForm
          bandSlug={band.slug}
          selectedDate={selectedDate}
          formMode={formMode}
          isPremium={band.membership_level === "premium"}
        />
      </LoadScript>

      <div className="flex justify-center mt-4">
      <ResponsiveButton
        type="button"
        variant="closeform"
        onClick={() => {
          setSelectedDate(null);
          setFormMode("palaute");
        }}
      >
        Sulje lomake
      </ResponsiveButton>
      </div>

    </>
  )}
</>

) : formMode === "palaute" && band ? (
  <>
    <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light mt-4">
      Voit antaa palautetta kirjoittamalla viestin tai antamalla tähtiä – Tähtien antaminen esiintyjän näkyvyyteen ja arvioihin.
    </p>

    {isPremium && (
  <p className="text-center xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-customFont1 text-darkest dark:text-shadow-lg dark:text-primary mt-2">
    ⭐ Premium-esiintyjille voit antaa tähtiä näkyvyyden ja arvioiden tueksi!
  </p>
)}

<LoadScript
  key={formMode} // 🔄 Tämä pakottaa uudelleenrenderöinnin kun formMode vaihtuu
  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
  libraries={["places"]}
  loadingElement={<div style={{ display: "none" }} />}
>
  {band && (
    <BookingForm
      bandSlug={band.slug}
      selectedDate={null}
      formMode="palaute"
      isPremium={isPremium}
    />
  )}
  <div className="flex justify-center mt-4">
    <ResponsiveButton
      onClick={() => setFormMode("setit")}
      className="w-48 text-xl"
    >
      <span className="flex items-center justify-center gap-2">
        <MdArrowBack className="text-xl" />
        Sulje lomake
      </span>
    </ResponsiveButton>
  </div>
</LoadScript>

  </>
) : formMode === "viesti" && band ? (
  <>
    <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light mt-4">
    Onko sinulla kysyttävää? Ota yhteyttä helposti tällä lomakkeella.
    </p>

    <LoadScript
    key={formMode}
  googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
  libraries={["places"]}
  loadingElement={<div style={{ display: "none" }} />}
>
  {band && (
    <BookingForm
      bandSlug={band.slug}
      selectedDate={null}
      formMode="viesti"
      isPremium={band.membership_level === "premium"}
    />
  )}
  <div className="flex justify-center mt-4">
    <ResponsiveButton
      onClick={() => setFormMode("setit")}
      className="w-48 text-xl"
    >
      <span className="flex items-center justify-center gap-2">
        <MdArrowBack className="text-xl" />
        Sulje lomake
      </span>
    </ResponsiveButton>
  </div>
</LoadScript>

  </>
) : (

  <>
    <div className="flex flex-col items-center justify-center mt-6 text-center">
      <p className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light mb-2">
        Haluatko antaa palautetta esiintyjästä?
      </p>
      <ResponsiveButton
        type="button"
        variant="closeform"
        onClick={() => {
          setSelectedDate(null);
          setFormMode("palaute");
        }}
      >
        🎉 Jätä palaute tästä 🎤
      </ResponsiveButton>
    </div>

    <div className="flex flex-col items-center justify-center mt-6 text-center">
  <p className="font-customFont1 dark:text-shadow-lg text-darkest dark:text-primary xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-light mb-2">
    Tai lähettää viestin?
  </p>
  <ResponsiveButton
    type="button"
    variant="closeform"
    onClick={() => {
      setSelectedDate(null);
      setFormMode("viesti");
    }}
  >
    ✉️ Lähetä viesti tästä
  </ResponsiveButton>
</div>

  </>
)}




        </div>
      </div>
    </div>
  );
};

export default BandProfile;
